// Utility: calculate how much of the element is visible in the viewport
function percentageSeen(element) {
  const rect = element.getBoundingClientRect()
  const viewportHeight = window.innerHeight

  if (rect.top > viewportHeight) return 0
  if (rect.bottom < 0) return 100

  const distance = viewportHeight - rect.top
  const percentage = (distance / (viewportHeight + rect.height)) * 100
  return Math.min(Math.max(Math.round(percentage), 0), 100)
}

// ScrollImage class
class ScrollImage extends HTMLElement {
  connectedCallback() {
    // Select all images inside this scroll-image element
    this.images = Array.from(this.querySelectorAll('.scroll-image__image'))

    if (!this.images.length) {
      console.warn('ScrollImage: no images found!', this)
      return
    }

    console.log('ScrollImage images found:', this.images)

    // Initial movement
    this.updateImages()

    // Update images on scroll
    window.addEventListener('scroll', () => this.updateImages(), {
      passive: true
    })
    window.addEventListener('resize', () => this.updateImages())
  }

  updateImages() {
    const seen = percentageSeen(this) / 100 // normalize to 0–1
    const maxMove = this.offsetHeight * 0.4 // max 30% of section height

    this.images.forEach((img, index) => {
      let move = 0
      if (index === 0) move = seen * maxMove // first image moves down
      if (index === 1) move = -seen * maxMove // second image moves up
      if (index === 2) move = seen * maxMove * 0.5 // third image slower

      img.style.transform = `translateY(${move}px)`
    })
  }
}

// Observe the document for dynamically added scroll-image elements
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.tagName === 'SCROLL-IMAGE' && !node.__scrollImageInitialized) {
        customElements.upgrade(node) // ensure it's upgraded if defined
        node.__scrollImageInitialized = true
        new ScrollImage().connectedCallback.call(node)
      }
    })
  })
})

observer.observe(document.body, { childList: true, subtree: true })

// Define the custom element
customElements.define('scroll-image', ScrollImage)

// Also initialize any scroll-image elements already in the DOM
document.querySelectorAll('scroll-image').forEach((el) => {
  if (!el.__scrollImageInitialized) {
    new ScrollImage().connectedCallback.call(el)
    el.__scrollImageInitialized = true
  }
})
